function api<T>(url: string, options?: RequestInit): Promise<T> {
    return fetch(url, options).then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const contentType = response.headers.get("Content-Type");

        if (/application\/json/.test(contentType)) {
            return response.json() as Promise<T>;
        }
        return (response.text() as any) as Promise<T>;
    });
}

export default api;
